
import { runJs, utils } from '@fangzhou/com-utils';
import { Data } from './constants';

export default function ({ env, data, inputs, outputs, logger }: RuntimeParams<Data>) {
    const { runtime } = env;
    if (runtime) {

        const { runImmediate } = data;

        if (runImmediate) {
            console.warn("my_node_runImmediate");
            outputs['output0']("my_node");
        }

        inputs['input0']((val) => {
            console.warn("my_node_input", val);
            outputs['output0'](`${val}_正`);
        });
    }
}
